<template>
  <!-- Celda REUTILIZABLE de fichero PDF con historial de versiones. En edición, botón de subir
       (cada PDF archiva el anterior como versión); si hay fichero, un círculo con el nº de versión
       que despliega el histórico (una fila debajo del registro, la pinta el contenedor con
       <prm-file-history>). Se usa en TODAS las subidas: avales, seguros, facturas, change orders,
       documentación y futuras. -->
  <span class="vf">
    <button v-if="editing" type="button" class="vf-up" :disabled="uploading"
            v-tip="file ? $t('prm_summary_s02_pdf_replace') : $t('prm_summary_s02_pdf_upload')" @click="pick">
      <b-icon pack="fas" :icon="uploading ? 'spinner' : 'upload'" :custom-class="uploading ? 'fa-spin' : ''" size="is-small"></b-icon>
    </button>
    <input ref="input" type="file" accept="application/pdf" class="vf-hidden" @change="onPick">

    <button v-if="file" type="button" class="vf-circle" :class="{ active: open }"
            v-tip="$t('prm_summary_s02_pdf_history')" @click="$emit('toggle-history')">{{ versionCount }}</button>

    <span v-if="!file && !editing" class="vf-empty">{{ $t('prm_summary_s02_pdf_none') }}</span>
  </span>
</template>

<script>
  import FileUploader from '~/plugins/fileUploader'
  import { tip } from '../shared/tip'

  export default {
    name: 'PrmVersionedFile',

    directives: { tip },

    props: {
      file: { type: Object, default: null },        // fichero actual (con versiones) o null
      uploadUrl: { type: String, required: true },  // endpoint de subida de la fila
      projectId: { type: [Number, String], required: true },
      editing: { type: Boolean, default: false },
      open: { type: Boolean, default: false },       // el histórico de esta fila está desplegado
    },

    data: () => ({ uploading: false }),

    computed: {
      // Nº de versión = anteriores + la actual (1 la primera subida).
      versionCount () { return (this.file && this.file.versions ? this.file.versions.length : 0) + 1 },
    },

    methods: {
      pick () { if (!this.uploading) this.$refs.input.click() },

      async onPick (e) {
        const f = e.target.files && e.target.files[0]
        e.target.value = '' // permite re-seleccionar el mismo fichero
        if (!f) return
        if (f.type !== 'application/pdf' && !/\.pdf$/i.test(f.name)) {
          this.$notify.error(this.$t('prm_summary_s02_pdf_only'))
          return
        }
        this.uploading = true
        try {
          const ok = await FileUploader.submitFile(f, {
            entityType: 'prm_contract_file',
            entityId: 0,
            projectId: this.projectId,
            uploadEndpoint: this.uploadUrl,
          })
          if (ok) this.$emit('uploaded')
          else this.$notify.error(this.$t('error_saving_data'))
        } catch (err) {
          this.$notify.error(this.$t('error_saving_data'))
        } finally {
          this.uploading = false
        }
      },
    },
  }
</script>

<style lang="scss" scoped>
  .vf { display: inline-flex; align-items: center; gap: 4px; }
  .vf-hidden { display: none; }

  // Botón de subir (cuadrado con borde, como el diseño).
  .vf-up {
    display: inline-flex; align-items: center; justify-content: center; border: 1px solid #d5dbe4;
    background: #fff; color: #6b7787; border-radius: 5px; width: 26px; height: 26px; cursor: pointer;
  }
  .vf-up:hover:not(:disabled) { background: #f6f9fc; }
  .vf-up:disabled { opacity: .6; cursor: not-allowed; }

  // Círculo con el nº de versión (despliega/repliega el histórico).
  .vf-circle {
    display: inline-flex; align-items: center; justify-content: center; min-width: 24px; height: 24px;
    padding: 0 6px; border-radius: 999px; background: #3d6b9a; color: #fff; font-size: 9px; font-weight: 700;
    border: 0; cursor: pointer; line-height: 1;
  }
  .vf-circle:hover, .vf-circle.active { background: #345d86; }
  .vf-empty { font-size: 11px; color: #9aa4b2; }
</style>
